import styled from "styled-components"

export const Wrapper = styled.div`
    height: 450px;
    padding: 30px;
`
export const Nav = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 20px;

`
export const Text = styled.div`
    display: inline;
    align-items: center;
    justify-content: center;

    h3 {
        color: var(--lightGrey);
    }
`